<template>
  <div class="mybottom">
    <div class="top">
      <div class="tit">{{ $t("a24") }}</div>
      <div class="txt" v-html="$t('a25')"></div>
      <!-- <div class="txt" v-html="$t('a26')"></div> -->
      <!-- <div class="txt" v-html="$log.textLink($t('a27'))"></div> -->
      <div class="txt" v-html="$log.textLink($t('a28'))"></div>
      <div class="txt" v-html="$t('a29')"></div>
      <div class="txt" v-if="Cookie">
        <span class="assd" v-html="$log.textLink($t('a531'))"></span>
        <span @click="showCookie" class="anniu">{{ $t("a535") }}</span>
      </div>
      <div class="footer">
        <img src="../../assets/img/footer.png" alt />
      </div>
    </div>
    <div class="deep">
      <p v-html="$log.textLink($t('a30'))"></p>
      <p style="margin: 20px 0">
        We have been informed that there is a potential entity/person with the
        domain rynattrading.org who has been and is impersonating our Company .
        Please be aware that the domain rynattrading.org does not belong to
        Rynat Trading Ltd. If you are contacted by someone claiming to be from
        Rynat Trading Ltd, please ensure you are certain who you are on the
        phone to.
      </p>
      <p style="margin-top: 20px">
        Deemed authorised and regulated by the Financial Conduct Authority. The
        nature and extent of consumer protections may differ from those for
        firms based in the UK. Details of the Temporary Permissions Regime,
        which allows EEA-based firms to operate in the UK for a limited period
        while seeking full authorisation, are available on the Financial Conduct
        Authority’s website.
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "mybottom",
  data() {
    return {
      Cookie: true
    };
  },
  methods: {
    showCookie() {
      this.Cookie = false;
      this.$log.setLocalStorage("showCooke", false);
    }
  },
  created() {
    this.Cookie =
      this.$log.getLocalStorage("showCooke") == "false" ? false : true;
  }
};
</script>
<style lang="less" scoped>
.mybottom {
  background-color: #f7f8fa;

  .top {
    padding: 0 20px;
    background-color: #f7f8fa;

    .tit {
      padding-top: 50px;
      margin: 0px auto 30px;
      text-align: center;
      color: #000;
      font-size: 25px;
      // font-weight: 700;
      text-shadow: 0px 0.5px 2px #000;
    }

    .txt {
      font-size: 12px;
      margin: 20px 0;
      .anniu {
        margin-left: 8px;
        display: inline-block;
        padding: 2px 5px 2px 2px;
        color: #fff;
        background-color: #159f42;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          right: 0;
          bottom: 0;
          width: 0;
          height: 0;
          border-right: 8px solid #f6f6f6;
          border-top: 8px solid transparent;
        }
      }
    }

    .footer {
      width: 94%;
      margin-bottom: 20px;
    }
  }

  .deep {
    padding: 20px 20px;
    color: #999;
    font-size: 12px;
    background-color: #e6e6e6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Mybottom/mybotton.vue